import { getTheme, IStyle, keyframes } from '@fluentui/react'

export const internal__getLazyImagePlaceholderStyles = () => {
  const theme = getTheme();

  const surface: IStyle = {
    margin: 0,
    padding: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.neutralLight,
    color: theme.palette.neutralQuaternary,
  };
  
  const icon: IStyle = {
    fontSize: 100,
  };

  return {
    surface,
    icon,
  };
}

export const internal__getLazyImageFrameStyles = () => {
    const theme = getTheme();
  
    const hiddenRoot: IStyle = {
      margin: 0,
      padding: 0,
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.palette.neutralPrimary,
      overflow: 'hidden',
      opacity: 0,
    };

    const fadeIn = keyframes({
        from: {
            opacity: 0,
        },
        to: {
            opacity: 1,
        },
    });

    const transistionRoot: IStyle = {
        ...hiddenRoot,
        animationName: fadeIn,
        animationDuration: '0.65s',
        animationFillMode: 'forwards', // retain end of animation value
        animationIterationCount: '1', // no repeat
        animationTimingFunction: 'linear',
    };

    const root: IStyle = {
        ...hiddenRoot,
        opacity: 1,
    };
    
    const image: IStyle = {
      height: '100%',
    };
  
    return {
      root,
      hiddenRoot,
      transistionRoot,
      image,
    };
}

export const internal__getLazyImageStyles = () => {
    const theme = getTheme();
  
    const root: IStyle = {
      margin: 0,
      padding: 0,
      width: '100%',
      height: '100%',
      position: 'relative',
      backgroundColor: theme.palette.neutralLight,
    };
  
    return {
      root,
    };
  }